<template>
  <div class="navBar">
    <div class="left" @click="goHome">
      <el-image class="logo" :src="require('@/assets/images/ibayPayLogo.png')" />
      <!-- <img class="logo" src="@/assets/images/ibayPayLogo.png" /> -->
    </div>
    <div class="right">
<!--      <div class="switchLanguage">-->
<!--        <el-select v-model="switchLanguage" @change="switchChange">-->
<!--          <el-option label="中 文" value="Chinese"></el-option>-->
<!--          <el-option label="English" value="English"></el-option>-->
<!--        </el-select>-->
<!--      </div>-->
      <el-tooltip placement="bottom-end" effect="light">
        <div slot="content" class="messsageBox" v-if="messageList.length > 0">
          <div
            :class="['eachMessage', 'cursor-pointer', item.hasRead ? 'hasRead' : '']"
            @click="goMessageList"
            v-for="item in messageList"
            :key="item.id">
            <p>{{ item.content }}</p>
            <p class="spaceBetween">
              <span class="time">{{ item.createdTime }}</span>
              <span v-if="!item.hasRead" class="toBeRead cursor-pointer" @click.stop="readEachMessage(item.id)">{{switchLanguage==='English'?'I see':'知道了'}}</span>
            </p>
          </div>
          <div class="flexCenter">
            <el-button type="text" @click="goMessageList">{{switchLanguage==='English'?'View all messages':'查看全部消息'}}</el-button>
          </div>
        </div>
        <div slot="content" class="messsageBox" v-if="messageList.length === 0">
            No message
        </div>
        <i v-show="user.status === 'approved'" @click="goMessageList" :class="['iconfont', 'iconnotification', 'cursor-pointer', hasNewMessage ? 'hasNewMsg' : 'noMsg' ]"><span v-if="hasNewMessage" class="notify"></span></i>
      </el-tooltip>
      <i v-if="user.status !== 'approved'" @click="showCertifyModel" class="iconfont iconnotification cursor-pointer"></i>
      <div class="userNameContainer">
        <span class="username">Hi, {{user.name}}</span>
        <span class="merchantNum">{{switchLanguage==='English'?'Merchant':'商户号'}}：{{ merchantNumber }}</span>
      </div>
      <el-dropdown>
        <el-avatar class="el-dropdown-link" :size="40" :src="user.avatar"></el-avatar>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="goSystemSetting">{{switchLanguage==='English'?'System settings':'系统设置'}}</el-dropdown-item>
          <el-dropdown-item @click.native="Logout">{{switchLanguage==='English'?'Log out':'退出登录'}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <NotCertified :showNotCertifi="showNotCertifi" @closeModel="closeModel" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getName } from '@/utils/auth'
import { parseTime } from '@/utils'
import { CommonService } from '@/api'
import NotCertified from '@/components/NotCertifiedModel'
export default {
  name: 'NavBar',
  props: {
  },
  components: {
    NotCertified
  },
  computed: {
    ...mapState({
      user: state => state.user,
      merchantNumber: state => state.user.merchantNumber,
      commonMessageList: state => state.app.commonMessageList
    }),
    hasNewMessage() {
      return this.messageList.filter(_ => !_.hasRead).length > 0
    },
  },
  watch: {
    commonMessageList() {
      this.messageList = this.commonMessageList.slice(0, 3)
    }
  },
  data() {
    return {
      messageList: [],
      // hasNewMessage: false,
      showNotCertifi: false,
      switchLanguage:''
    }
  },
  created() {
    this.userName = getName()
    this.getMessageList()
    this.switchLanguage=window.sessionStorage.getItem('language')?window.sessionStorage.getItem('language'):'English'
  },
  methods: {
    goSystemSetting() {
      this.$router.push('/systemSetting')
    },
    showCertifyModel() {
      this.showNotCertifi = true
    },
    closeModel() {
      this.showNotCertifi = false
    },
    Logout() {
      this.$store.dispatch('user/logout').then(res => {
        this.$router.push('/login')
      })
    },
    goHome(e) {
      this.$router.push('/')
    },
    getMessageList() {
      let params = {
        page: {
          pageNumber: 1,
          pageSize: 3
        },
        searchData: {}
      }
      CommonService.queryMessageList(params).then(res => {
        this.messageList = res.data.content.map(_ => {
          _.createdTime = parseTime(_.createdTime)
          return _
        })
        // this.ifshowNotify()
      })
    },
    // ifshowNotify() {
    //    this.hasNewMessage = this.messageList.filter(_ => !_.hasRead).length > 0
    // },
    goMessageList() {
      this.$router.push({name: 'systemSetting', query: {tabName: 'message'}})
    },
    readEachMessage(id) {
      CommonService.readMessage({ systemMessageId: id }).then(res => {
        if (res.status) {
          this.getMessageList()
        }
      })
    },
    switchChange(){
      window.sessionStorage.setItem('language',this.switchLanguage)
      this.$router.go(0)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "~@/styles/variables.scss";
.navBar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  overflow: hidden;
  justify-content: space-between;
  padding: 0 30px;
  height: $navBarHeight;
  z-index: 1001;
  box-shadow:0px 5px 10px 0px rgba(232,232,235,0.5);
  background: #fff;
  .left{
    color: #006EFF;
    font-size: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
    .logo {
      width: 180px;
    }
  }
  .right{
    display: flex;
    align-items: center;
    .iconnotification {
      font-size: 24px;
      position: relative;
      &.hasNewMsg {
        color: #132F62;
      }
      &.noMsg {
        color: #E8E8EB;
      }
      .notify {
        width: 8px;
        height: 8px;
        background: red;
        content: '';
        display: inline-block;
        border-radius: 50%;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .userNameContainer {
      display: flex;
      flex-direction: column;
      align-items: flex-end;;
      margin: 0 10px 0 30px;
      .username{
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        color: #132F62;
      }
      .merchantNum {
        color: #BEBEC8;
        font-size: 12px;
      }
    }
    .el-dropdown-link {
      cursor: pointer;
    }
    .switchLanguage{
      margin-right: 20px;
      width: 155px;
      input{
        font-size: 10px;
      }
    }
  }
}
.messsageBox {
  max-width: 320px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(19,47,98,1);
  line-height: 18px;
  .eachMessage {
    padding: 10px 0;
    border-bottom: 1px solid rgba(243,244,246,1);
    &.hasRead {
      color: #BEBEC8;
    }
    .time {
      transform-origin: 0 50%;
      transform: scale(0.83);
      text-align: left;
    }
    .toBeRead {
      color: #006EFF;
    }
  }
  .el-button {
    color:rgba(19,47,98,1);
    padding: 10px 0 0;
  }
}

</style>
